/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('UtpSimTestSuitesServiceApi', ($http, ApiErrorService) => {
    return {
        getSimModel: getSimModel,
        simulatorTestSuites: simulatorTestSuites,
        addTestSuite: addTestSuite,
        removeTestSuite: removeTestSuite,
        removeTestCase: removeTestCase,
        addTestCase: addTestCase
    };
    function getSimModel(simId, testSuiteId) {
        return $http.get(`api/UtpSimTestSuites/GetSimModel?simId=${simId}&testSuiteId=${testSuiteId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function simulatorTestSuites(simId) {
        return $http.get(`api/UtpSimTestSuites/SimulatorTestSuites?simId=${simId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function addTestSuite(req) {
        return $http.post(`api/UtpSimTestSuites/AddTestSuite`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function removeTestSuite(req) {
        return $http.post(`api/UtpSimTestSuites/RemoveTestSuite`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function removeTestCase(req) {
        return $http.post(`api/UtpSimTestSuites/RemoveTestCase`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function addTestCase(req) {
        return $http.post(`api/UtpSimTestSuites/AddTestCase`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
